import generalUpload from "../_section/upload.class";
export class userInvestmentStatementUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [{
        name: 'accountNumber',
        label: 'Account Number',
        type: 'text',
    }, {
        name: 'closingBalance',
        label: 'Closing Balance',
        type: 'currency',
        scan: 'closingBalance',
        optional: true
    }, {
        name: 'startDate',
        label: 'Start Date',
        type: 'date',
        scan: 'startDate',
        optional: true
    }, {
        name: 'documentDate',
        label: 'End Date',
        type: 'date',
        scan: 'endDate',
        optional: true
    }]
}
export class adminInvestmentStatementUpload extends userInvestmentStatementUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                range:{
                    from: {date: this.values.startDate},
                    to: {date: this.values.documentDate},
                },
                expires: this.values.documentDate.add('6','month'),
            })
        }
        if (!upload.examined){
            this.problems.push('Not Examined');
        }
    }


}
